import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface ConfirmPopUpSkeletonData {
    title: string;
    positiveButtonText: string;
    negativeButtonText: string;
}

@Component({
    selector: 'app-confirm-pop-up-skeleton',
    styleUrls: ['./confirm-pop-up-skeleton.component.css'],
    templateUrl: './confirm-pop-up-skeleton.component.html'
})
export class ConfirmPopUpSkeletonComponent<T> {
    constructor(
        public dialogRef: MatDialogRef<T>,
        @Inject(MAT_DIALOG_DATA) public readonly popUpData: ConfirmPopUpSkeletonData) {
    }

    decline(): void {
        this.dialogRef.close();
    }
}